import { render, staticRenderFns } from "./MarsManager.vue?vue&type=template&id=d8cb2cc2&"
import script from "./MarsManager.vue?vue&type=script&lang=js&"
export * from "./MarsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports